import * as sharedTypes from 'src/actions/shared/sharedTypes';
import endpointsResource from 'src/actions/endpoints/endpointsResource';

const VALID_ADDRESS_REGEX = /^[a-zA-Z0-9._-]*$/i;

export const validateAddress: sharedTypes.AppThunk = (currentValue: any) => dispatch => {
  if (!VALID_ADDRESS_REGEX.test(currentValue.address.trim())) {
    dispatch(
      endpointsResource.actions.validationError([
        {
          attr: 'address',
          code: 'AddressContainsNotAllowedSymbols',
          detail: 'Name contains invalid characters. Allowed characters are a-zA-Z0-9_-',
        },
      ])
    );
    return false;
  }
  return true;
};
